import React, { useState, useEffect } from 'react'
// import { Charts, ChartContainer, ChartRow, YAxis, XAxis, LineChart, Baseline, Legend, Resizable, styler } from "react-timeseries-charts";
// import { TimeSeries, TimeRange } from "pondjs"
import moment from 'moment';
import axios from 'axios'

import { Line } from 'react-chartjs-2';


import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


    

const options = {
    scales: {
    yAxes: [
        {
        type: 'linear',
        display: true,
        position: 'left',
        id: 'y-axis-1',
        },
        // {
        // type: 'linear',
        // display: true,
        // position: 'right',
        // id: 'y-axis-1',
        // gridLines: {
        //     drawOnArea: false,
        // },
        // },
    ],
    },
};
    

function Chart(props) {
    const stats = props.stats
    const [data, setData] = useState({})
    const [isLoading, setIsLoading] = useState(true)
    const [latestGraph, setLatestGraph] = useState("loading")
    const [fromRange, setFromRange] = useState(moment().subtract({ hours : 24 }))
    const [toRange, setToRange] = useState(moment())
    const [timePoints, setTimePoints] = useState([])
    const [khPoints, setKhPoints] = useState([])
    const [cckcPoints, setCckcPoints] = useState([])
    const [khts, setKHTS] = useState([])
    const [cckcts, setCCKTS] = useState([])
    const [maxCapacity, setMaxCapacity] = useState(0)
    const color = "red";
    const highlightColor = "#5a98cb"
    // const capacityStyle = styler([{ key: "capacity_kh", color: "orange" }, { key: "capacity_cckc", color: "purple" }]);

    const fetchLatestGraph = () => {
        axios.get('https://3br6dqck1g.execute-api.ap-southeast-1.amazonaws.com/default/afs-fetch-graph').then(
            res => {
                // setLatestGraph(res.data)
                setKhPoints([])
                setCckcPoints([])
                setTimePoints([])

                res.data.kh.forEach((point) => {
                    let tempKh = khPoints
                    tempKh.push(point[1])
                    let tempTime = timePoints
                    tempTime.push(moment.unix(point[0]).format("h:mmA"))
                    setKhPoints(tempKh)
                    setTimePoints(tempTime)
                })
                res.data.cckc.forEach((point) => {
                    let tempCckc = cckcPoints
                    tempCckc.push(point[1])
                    setCckcPoints(tempCckc)
                })
                
                console.log(khPoints, cckcPoints, timePoints)
                setData({
                    labels: timePoints,
                    datasets: [
                    {
                        label: 'Keat Hong',
                        data: khPoints,
                        fill: false,
                        backgroundColor: 'orange',
                        borderColor: 'orange',
                        yAxisID: 'y-axis-1',
                        pointRadius: 1,
                        pointHoverRadius: 9, 
                        tension: 0.5
                    },
                    {
                        label: 'CCKC',
                        data: cckcPoints,
                        fill: false,
                        backgroundColor: 'purple',
                        borderColor: 'purple',
                        yAxisID: 'y-axis-1',
                        pointRadius: 1,
                        pointHoverRadius: 9, 
                        tension: 0.5
                    },
                    ],
                })
                setIsLoading(false)
            }
        )
    }

    useEffect(() => {
        fetchLatestGraph()
    }, [])


    // const kh = new TimeSeries({
    //     name: "kh",
    //     columns: ["time", "capacity_kh"],
    //     points: [
    //         [moment().subtract({ hours : 24 }), 5],
    //         [moment().subtract({ hours : 12 }), 5],
    //         [moment(), 7],
    //     ]
    // })

    // const cckc = new TimeSeries({
    //     name: "cckc",
    //     columns: ["time", "capacity_cckc"],
    //     points: [
    //         [moment().subtract({ hours : 24 }), 5],
    //         [moment().subtract({ hours : 12 }), 5],
    //         [moment(), 7],
    //     ]
    // })


    const calculateMax = () => {
        let max = 0
        khPoints.forEach(e => {
            if (e[1] > max) {
                max = e[1]
            }
        }); 

        cckcPoints.forEach(e => {
            if (e[1] > max) {
                max = e[1]
            }
        }); 

        // return (max + 1)
    }
    return (
        <>
            { isLoading ?
            <>
            <Skeleton 
            baseColor="#dec2ff"
            highlightColor="#f7f0ff"
            width={"100%"}
            height={"12em"}/>
            <p></p>
            </>
            :
            <>

                <Line data={data} options={options} />
                {/* <Resizable>
                    <ChartContainer timeRange={new TimeRange(fromRange, toRange)} 
                    // format={"%H"}
                    format={(e) => { 
                        return moment(e).format("ha") 
                    }}
                    timeAxisTickCount={10}
                    >
                        <ChartRow height={300}>
                            <YAxis id="axis1" label="Capacity" min={0} max={48} width="50" type="linear" format="," style={capacityStyle}/>
                            <Charts>
                                <LineChart axis="axis1" series={khts} columns={["capacity_kh"]} style={capacityStyle}/>
                                <LineChart axis="axis1" series={cckcts} columns={["capacity_cckc"]} style={capacityStyle}/>
                            </Charts>
                        </ChartRow>
                    </ChartContainer>
                </Resizable> */}
            </>
            }

<div>
                    <p className="text-gray-700 text-sm mb-0">{ isLoading ? "Loading Chart.." : "Viewing Past 24 Hours" }</p>
                    {/* <div className="flex flex-row text-center justify-center">
                        <p className="font-bold text-sm mr-3 text-center" style={{ color: "orange" }}>Keat Hong</p>
                        <p className="font-bold text-sm text-center" style={{ color: "purple" }}>CCKC</p>
                    </div> */}
                    
                        <p className="mt-1 mb-4 text-xs md:text-sm sm:hidden text-gray-300 text-center"
                        >
                            Rotate your device to enlarge chart 
                        </p>

                <div className="grid grid-cols-12 gap-2">
                                    <div className="col-span-3">
                                    </div>
                                    <div className="col-span-3">
                                        <h1 className="text-center text-3xl font-bold text-orange-400 mb-1">
                                            
                                                {
                                                    isLoading ?
                                                    <Skeleton 
                                                    baseColor="#dec2ff"
                                                    highlightColor="#f7f0ff"
                                                    width={"1.2em"}/>
                                                    :
                                                    stats.kh
                                                }
                                        </h1>
                                        <h4 className="text-center sm:text-lg font-bold text-xs text-orange-300">
                                            Keat Hong
                                        </h4>
                                        <h4 className="text-center text-sm text-orange-300">
                                            Max: 37
                                        </h4>
                                    </div>
                                    <div className="col-span-3">
                                        <h1 className="text-center text-3xl font-bold text-purple-700 mb-1">
                                                {
                                                    isLoading ?
                                                    <Skeleton 
                                                    baseColor="#dec2ff"
                                                    highlightColor="#f7f0ff"
                                                    width={"1.2em"}/>
                                                    :
                                                    Number.isNaN(stats.cckc) ?
                                                    "?" : stats.cckc
                                                }
                                        </h1>
                                        <h4 className="text-center sm:text-lg font-bold text-xs text-purple-500">
                                            CCKC
                                        </h4>
                                        <h4 className="text-center text-sm text-purple-500">
                                            Max: 46
                                        </h4>
                                    </div>
                </div>

                    <p className="mt-4 text-sm md:text-md text-purple-300 text-center">
                        {
                            isLoading ?
                            <Skeleton 
                            baseColor="#de
                            c2ff"
                            highlightColor="#f7f0ff"
                            width={"10.5em"}/>
                            :
                            "Updated " + moment.unix(stats.timestamp).fromNow()
                        }
                    </p>
                    <p className="text-center text-sm">
                    <Link to="/">
                        <button className="mt-6 mb-2 self-start justify-self-start bg-purple-500 hover:bg-purple-700 text-white py-2 px-5 rounded-full">Back to Home</button>
                    </Link>
                    </p>
                    
                </div>
        </>
    )
}

export default Chart
